export default function stockNotificationStatus(triggeredByChange = false) {
  let max = parseInt($(".stock-notification").data("notification-trigger"));
  let maxFromSelect = parseInt(
    $(".js-main-select").find("option:selected").data("max")
  );
  let $quantityInputProduct = $(".js-quantity-input-pdp");
  let quantityInputProductVal = parseInt($quantityInputProduct.val());

  if (triggeredByChange) {
    switch (triggeredByChange) {
      case "show":
        $(".stock-notification").removeClass("hidden");
        break;

      default:
        $(".stock-notification").addClass("hidden");
        break;
    }
  } else {
    if (max >= maxFromSelect && maxFromSelect > 0) {
      $(".stock-notification").removeClass("hidden");
    } else {
      $(".stock-notification").addClass("hidden");
    }
  }
  // $('.stock-notification').find('span').text(maxFromSelect);

  if (quantityInputProductVal > maxFromSelect) {
    $quantityInputProduct.val(
      maxFromSelect > 0 ? maxFromSelect : quantityInputProductVal
    );
  }

  $quantityInputProduct.attr("max", maxFromSelect);
}
